import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import Card from "./Card";
import LockPeriod from "./LockPeriod";
import StakeForm from "./StakeForm";
import TokenRate from "./TokenRate";
import FAQ from "./FAQ";
import { ethers } from "ethers";
import stakingABI from "../../../../Staking.json";
import tokenABI from "../../../../TokenABI.json";

const Dashboard = ({ account }) => {
  const [message, setMessage] = useState("");
  const [totalValueStaked, setTotalValueStaked] = useState("");
  const [stakers, setStakers] = useState("");
  const [signer, setSigner] = useState(null);
  const [tokenContract, setTokenContract] = useState(null);
  const [stakingContract, setStakingContract] = useState(null);

  const stakingContractAddress = "0xf57ae70f5e25c4617973c812d5beb5e7a2d90c6e";
  const tokenAddress = "0x978bF545a15e29595E6C583aefA76f5Fe71070c2";

  useEffect(() => {
    const provider = new ethers.providers.Web3Provider(window.ethereum);

    if (provider) {
      provider
        .send("eth_requestAccounts", [])
        .then(() => {
          const signerInstance = provider.getSigner();
          setSigner(signerInstance);

          const tokenInstance = new ethers.Contract(
            tokenAddress,
            tokenABI,
            signerInstance
          );
          setTokenContract(tokenInstance);

          const stakingInstance = new ethers.Contract(
            stakingContractAddress,
            stakingABI,
            signerInstance
          );
          setStakingContract(stakingInstance);
        })
        .catch((err) => {
          console.error("Error requesting accounts", err);
        });
    } else {
      console.error("Ethereum object not found, install MetaMask.");
      setMessage("Ethereum object not found, install MetaMask.");
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (stakingContract) {
        try {
          const totalValueStakedWei = await stakingContract.totalValueLocked();
          const stakersCount = await stakingContract.totalStakers();

          setTotalValueStaked(
            ethers.utils.formatUnits(totalValueStakedWei, 18)
          );
          setStakers(stakersCount.toString());
        } catch (error) {
          console.error("Error fetching data:", error);
          setMessage("Failed to fetch staking data");
        }
      }
    };

    fetchData();
  }, [stakingContract]);

  async function approveTokenIfNeeded(
    tokenContract,
    stakingContractAddress,
    amount
  ) {
    if (!signer) {
      console.error("Signer not initialized");
      return;
    }
    const userAddress = await signer.getAddress();
    const amountInWei = ethers.utils.parseUnits(amount.toString(), 18);

    const currentAllowance = await tokenContract.allowance(
      userAddress,
      stakingContractAddress
    );
    if (currentAllowance.lt(amountInWei)) {
      console.log("Approving tokens...");
      const txResponse = await tokenContract
        .connect(signer)
        .approve(stakingContractAddress, amountInWei);
      await txResponse.wait();
      console.log(`Approval transaction hash: ${txResponse.hash}`);
    } else {
      console.log("Sufficient allowance already set.");
    }
  }

  const handleStake = async (amount, duration) => {
    console.log("Initiating staking process...");
    try {
      await approveTokenIfNeeded(tokenContract, stakingContractAddress, amount);
      console.log("Approval check passed, proceeding to stake...");

      const formattedAmount = ethers.utils.parseUnits(amount, 18);
      console.log(`Staking ${formattedAmount} for duration ${duration}`);
      const tx = await stakingContract
        .connect(signer)
        .stake(formattedAmount, duration);
      await tx.wait();
      console.log("Staked successfully!");
      setMessage("Staked successfully!");
    } catch (error) {
      console.error("Error staking:", error);
      setMessage(`Error staking: ${error.message}`);
      if (error.message.includes("cannot estimate gas")) {
        alert("Transaction is time-locked. Please try again later.");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  };

  return (
    <div className="dashboard">
      <div className="stats">
        <Card
          title="Total Value Staked"
          value={`$ ${(totalValueStaked * 0.072).toFixed(2)}`}
        />
        <Card title="Total INFINITY Staked" value={totalValueStaked} />
        <Card title="Stakers" value={stakers} />
        <Card title="Current INFINITY Price" value="$0.072" />
      </div>
      <div className="main-content">
        <StakeForm
          tokenContract={tokenContract}
          stakingContract={stakingContract}
          handleStake={handleStake}
        />
        <LockPeriod contract={stakingContract} account={account} />
      </div>
      <div className="bottom-content">
        <TokenRate account={account} contract={stakingContract} />
      </div>
      <FAQ />
    </div>
  );
};

export default Dashboard;
